import { gql } from "graphql-request";

export const CREATE_TENANT_ROLE = gql`
  mutation CreateTenantRole($input: CreateTenantRoleInput!) {
    createTenantRole(input: $input) {
      id
      tenantId
      departmentId
      name
      description
      resourcingType
      coverageStatus
      externalProviderName
      coverageNotes
      mission
      reportsToRoleId
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const UPDATE_TENANT_ROLE = gql`
  mutation UpdateTenantRole($input: UpdateTenantRoleInput!) {
    updateTenantRole(input: $input) {
      id
      tenantId
      departmentId
      name
      description
      resourcingType
      coverageStatus
      externalProviderName
      coverageNotes
      mission
      reportsToRoleId
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const DELETE_TENANT_ROLE = gql`
  mutation DeleteTenantRole($id: ID!) {
    deleteTenantRole(id: $id)
  }
`;